<section class="panel-wrapper">
  <gen-overlay-loader class="loader" *ngIf="!load" [showOverlay]="false"></gen-overlay-loader>

  <div *ngIf="(currentFilter$ | async)" class="Flexbox Flexbox__box-direction-column filter-container">
    <div class="Flexbox Flexbox__box-direction-column Flexbox__flex-1 filterPanel">
      <header class="filter-panel-header">
        <div class="fs6 bold filter-list-icons">
          <p-dropdown class="filter-list-part"
                      [options]="filterItems"
                      [(ngModel)]="selectedFilterItem"
                      (onChange)="onChangeSelectedFilter($event)">

            <ng-template let-item pTemplate="selectedItem">
              <span *ngIf="item.value.id === '0'" class="manage-filter-option icon__setting manage-icon"></span>
              {{item.label | stringTranslate}}
            </ng-template>
            <ng-template let-filter pTemplate="item">
              <span *ngIf="filter.value.id === '0'" class="manage-filter-option icon__setting manage-icon"></span>
              {{filter.label | stringTranslate}}
            </ng-template>
          </p-dropdown>
          <span class="filter-icons-part icon__filter fs3 pointer" *ngIf="enableStatistics"
                (click)="filterSelectedSection = 'filter';"
                [ngClass]="{'active':filterSelectedSection =='filter'}"
                style="color: #1076a6;">
          </span>
          <span class="filter-icons-part icon__statistics fs3 pointer" *ngIf="enableStatistics"
                (click)="filterSelectedSection = 'statistics';"
                [ngClass]="{'active':filterSelectedSection =='statistics'}"
                style="color: #1076a6; margin-left: 0.57rem;">
          </span>
        </div>
      </header>
      <div class="filter-scroll-parent" scroll-parent>
        <ng-container *ngIf="!isForm">
          <gen-filters-sections *ngIf="filterSelectedSection == 'filter'"
                                [filtersSections]="selectedFilterCategories"
                                class="section-panels"
                                id="gen-filters-sections-upgrade">
          </gen-filters-sections>
          <gen-statistics-sections *ngIf="enableStatistics && filterSelectedSection == 'statistics'"
                                     [statisticsSections]="selectedFilterCategories"
                                     class="section-panels"
                                     [ngClass]="{active:filterSelectedSection =='statistics'}"
                                     id="new-gen-statistics-sections-upgrade">
          </gen-statistics-sections>
        </ng-container>

        <ng-container *ngIf="isForm">
          <ng-container *ngFor="let category of inputConfig | keyvalue; index as i">
            <section class="Flexbox Flexbox__box-direction-column Marginbox__b-tiny filter-section">
              <header (click)="formConfig[category.key].toggle=!formConfig[category.key].toggle" class="category">
                <span class="fs7 category-icon"
                      [ngClass]="{icon__expand:!formConfig[category.key].toggle, icon__collapse:formConfig[category.key].toggle}"></span>
                <span class="fs6_5">{{category.key | translate}}</span>
              </header>
              <div [hidden]="formConfig[category.key].toggle" class="filter-group fs6_5 filter-dynamic-form">
                <gen-dynamic-form #filterDynamicForm
                                  [formName]="category.value.formId"
                                  [formData]="formData[category.key]"
                                  [disabled]="false"
                                  [formVertical]="category.value.formVertical"
                                  [stayInFormMode]="true"
                                  [listenToDataChange]="true"
                                  [visibleFieldsDetails]="visibleFilterFieldsDetails"
                                  (formChange)="formChange($event.form,category.key)"
                                  (formInitCompleted)="onFormInit($event)"
                >
                </gen-dynamic-form>
              </div>
            </section>
          </ng-container>
        </ng-container>

      </div>
      <div class="Flexbox filter-panel-buttons" [ngClass]="{'admin-filter-panel-margin':!isFullScreen}">
        <span id="cleanFilterBtn" class="Flexbox__align-self-center pointer fs6_5 btn-clear-filters" (click)="clearFilterProperties()">{{clearFilterTranslateKey | translate}}</span>
        <div *ngIf="!filterAdminMode" class="Flexbox Flexbox__flex-1 Flexbox__just-end" style="margin: 0 auto;">
            <gen-button id="saveFilterBtn" class="Marginbox__r-small"
              [text]="saveBtn | translate"
              (click)="saveFilter()"
              [type] = "'secondary'">
            </gen-button>
            <gen-button id="applyFilterBtn"
              [text]="applyBtn | translate"
              (click)="applyFilter()">
            </gen-button>
        </div>
      </div>
    </div>
  </div>
</section>
